export default __webpack_public_path__ + "static/media/menu_logo.fa38652d.svg";